<template>
  <div class="star-rating">
    <div class="stars-container">
      <button
        v-for="star in 5"
        :key="star"
        @click="selectRating(star)"
        @mouseenter="hoverRating = star"
        @mouseleave="hoverRating = 0"
        class="star-button"
        :class="{ active: star <= displayRating }"
        :aria-label="`Avaliar com ${star} estrela${star > 1 ? 's' : ''}`"
        :disabled="disabled"
      >
        <svg
          width="35"
          height="35"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="star-icon"
        >
          <path
            d="M12 2L14.09 8.26L22 9.27L17 14.14L18.18 22.02L12 18.77L5.82 22.02L7 14.14L2 9.27L9.91 8.26L12 2Z"
            :fill="getStarFill(star)"
            :stroke="getStarStroke(star)"
            stroke-width="2"
          />
        </svg>
        
        <div 
          v-if="hoverRating === star"
          class="tooltip"
        >
          {{ getTooltipText(star) }}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { StarColorType } from '../domain/entity/StarColorType';

export default {
  name: 'SurveyBoxStar',
  
  props: {
    initialRating: {
      default: 0
    },
    disabled: {
      default: false
    }
  },
  
  emits: ['rating-change'],
  
  data() {
    return {
      selectedRating: this.initialRating,
      hoverRating: 0,
    }
  },
  
  computed: {
    displayRating() {
      return this.hoverRating > 0 ? this.hoverRating : this.selectedRating
    }
  },
  
  methods: {
    selectRating(rating) {
      this.selectedRating = rating
      this.$emit('rating-change', rating)
    },
    
    getTooltipText(star) {
      return `${star}`;
    },
    getStarFill(star) {
      return star <= this.displayRating ? StarColorType['BLUE'] : StarColorType['TRANSPARENT']
    },
    getStarStroke(star) {
      return star <= this.displayRating ? StarColorType['BLUE']: StarColorType['GRAY']
    },
  },
  
  watch: {
    initialRating: {
      handler(newValue) {
        this.selectedRating = newValue
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.star-rating {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  font-family: 'Inter', sans-serif;
}

.stars-container {
  display: flex;
  gap: 4px;
  padding: 8px;
}

.star-button {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.star-button:hover {
  transform: scale(1.1);
}

.star-icon {
  transition: all 0.2s ease;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.star-button.active .star-icon {
  filter: drop-shadow(0 2px 8px rgba(255, 215, 0, 0.3));
}

.tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1a1a1a;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 8px;
  opacity: 0;
  animation: fadeIn 0.2s ease forwards;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1a1a1a;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.rating-text {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  text-align: center;
}

/* Tema claro */
@media (prefers-color-scheme: light) {
  .tooltip {
    background: #334155;
    color: white;
  }
  
  .tooltip::after {
    border-top-color: #334155;
  }
  
  .rating-text {
    color: #475569;
  }
}

@media (max-width: 480px) {
  .star-button {
    padding: 4px;
  }
  
  .star-icon {
    width: 20px;
    height: 20px;
  }
}
</style>